import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles/app.scss';
import './styles/app-mobile.scss';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);